module.exports = __webpack_public_path__ + "img/member.920d68ca.jpg";